import { defaultAutoLayoutFrame, defaultAutoLayoutItem } from './landingEditorAutoLayout.js';
import type { LandingEditorElementFrame } from './landingEditorTypes.js';

export { normalizeFluidSize, resizeFluidItems, fluidItemStyles, type FluidItemSize } from '@adornis/web-editor/fluid-layout.js';
/** Seed the mission hero once, including existing publications. Later editor sizes remain authoritative. */
export const ensureMissionFluidLayout = (frames: Record<string, LandingEditorElementFrame>) => {
  const prefix = 'static.ueber-vivaporta.hero';
  if (frames[`${prefix}.layout`]?.fluidLayout !== undefined) return frames;
  const layout = frames[`${prefix}.layout`] ?? { x: 0, y: 0 };
  frames[`${prefix}.layout`] = {
    ...layout, x: 0, y: 0, fluidLayout: true,
    autoLayoutDesktop: { ...defaultAutoLayoutFrame('wrap'), gapX: 56, gapY: 32, alignY: 'center', ...layout.autoLayoutDesktop },
    autoLayoutMobile: { ...defaultAutoLayoutFrame('wrap'), gapX: 24, gapY: 32, alignY: 'center', ...layout.autoLayoutMobile },
  };
  for (const [index, suffix] of ['copy', 'heroImage'].entries()) {
    const current = frames[`${prefix}.${suffix}`] ?? { x: 0, y: 0 };
    frames[`${prefix}.${suffix}`] = {
      ...current, x: 0, y: 0,
      ...(suffix === 'heroImage' ? { imageMaskDesktop: true, imageMaskMobile: true } : {}),
      fluidSize: suffix === 'heroImage' ? { width: 540, height: 360 } : { width: 540 },
      autoLayoutItemDesktop: { ...defaultAutoLayoutItem(index), widthMode: 'fill' },
      autoLayoutItemMobile: { ...defaultAutoLayoutItem(index), widthMode: 'fill' },
    };
  }
  return frames;
};
